import axios from 'axios'

export async function getUserData() {
  const selector = document.querySelector('meta[name="api-token"]')
  if (!selector) {
    return false
  }

  const token = selector.getAttribute('content')

  const getUserData = await axios({
    method: 'get',
    url: `/api/user?api_token=${token}`
  })

  return getUserData
}

export function isPC() {
  const width = window.parent.screen.width
  return width >= 900
}

export function numberFormatAddComma(num: number) {
  return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
}

export function getBirthdayPreviewHtml(birthday: string): string {
  const splitStr = birthday.indexOf('-') > -1 ? '-' : '/'
  const dayArr = birthday.split(splitStr)

  return `${dayArr[0]}年${Number(dayArr[1])}月${Number(dayArr[2])}日`
}

export function getAddressPreviewHtml(
  zip: string | null,
  prefecture: string | null,
  city: string | null,
  town: string | null
) {
  let res = ''

  if (zip) {
    const zip1 = zip ? zip.substr(0, 3) : ''
    const zip2 = zip ? zip.substr(3, 4) : ''
    res += `${zip1}-${zip2}<br>`
  }

  const add1 = prefecture ? prefecture : ''
  const add2 = city ? city : ''
  const add3 = town ? town : ''

  res += `${add1}${add2}${add3}`

  return res
}

export function dateFormat(dt: string, sameDate = false, showDay = true) {
  const week = ['日', '月', '火', '水', '木', '金', '土']

  const d = new Date(dt.replace(/-/g, '/'))

  let date = d.getFullYear() + '年'
  date += d.getMonth() + 1 + '月'
  date += d.getDate() + '日'
  if (showDay) date += '(' + week[d.getDay()] + ')'

  let time = d.getHours() + '時'
  time += ('00' + d.getMinutes()).slice(-2) + '分'

  return sameDate ? time : `${date} ${time}`
}

// イベントの期間をフォーマットする
export function getEventTerm(term_start: string, term_end: string): string {
  const start = new Date(term_start)
  const end = new Date(term_end)

  if (
    `${start.getFullYear()}${start.getMonth()}${start.getDate()}` ===
    `${end.getFullYear()}${end.getMonth()}${end.getDate()}`
  ) {
    return dateFormat(term_start) + '～' + dateFormat(term_end, true)
  } else {
    return dateFormat(term_start) + '～' + dateFormat(term_end)
  }
}

export function getEventPlace(event: any): string {
  if (event.type === 'オンライン' && event.place_name) return event.place_name
  if (event.type === 'オフライン')
    return `${event.place_name}(${event.place_prefecture}${event.place_city})`
  return ''
}

export function getEventTypes(event: any): string[] {
  // baseType イベントカテゴリのキャリアガイダンス優先 、オンライン or オフライン
  const baseType =
    event.category?.name === 'キャリアガイダンス'
      ? 'キャリアガイダンス'
      : event.type
  const otherTypes = event.cast_type.map((type: any) => type.label)
  const filterTypes = event.filter_type.map((type: any) => type.label)
  return [baseType, ...otherTypes, ...filterTypes]
}

// JSONが不正かどうか判定
export function isValidJson(value: string) {
  try {
    JSON.parse(value)
  } catch (e) {
    return false
  }
  return true
}
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
dayjs.locale('ja')

export const formatDateToTime = (date: string) =>
  dayjs(date).format('YYYY年M月D日（ddd）H時mm分')
